import LngLatFormat from "../Enums/LngLatFormat";
import GeoHelper from "./GeoHelper";

const StringHelper = {

};
StringHelper.findUrl = (text) => {
	let foundUrlAtIndex = text.indexOf("<a href=");
	if (foundUrlAtIndex === -1) {
		return null;
	}
	// Sometimes there is no `"` around the url.
	if (text.substr(foundUrlAtIndex + 8, 1) === "h") {
		foundUrlAtIndex += 8;
	}
	else {
		foundUrlAtIndex += 9;
	}

	let endIndex = text.indexOf(">", foundUrlAtIndex);
	if (endIndex === -1) {
		return null;
	}
	if (text.substr(endIndex - 1, 1) === "\"") {
		endIndex -= 1;
	}
	const link = text.substr(foundUrlAtIndex, endIndex - foundUrlAtIndex);
	// console.log("link", link);
	if (!StringHelper.isValidHttpUrl(link)) {
		return null;
	}
	return link;
};
StringHelper.isValidHttpUrl = (string) => {
	let url;
	try {
		url = new URL(string);
	}
	catch (_) {
		return false;
	}
	return url.protocol === "http:" || url.protocol === "https:";
};
StringHelper.ucfirst = (str) => {
	return str.substr(0, 1).toUpperCase() + str.substr(1);
};
StringHelper.formatDaysHoursAndMinutes = (inputDays) => {
	const days = Math.floor(inputDays);
	const hours = (inputDays % 1) * 24;
	let str = (days > 0)
		? days + " days "
		: "";
	str += StringHelper.formatHoursAndMinutes(hours);
	return str;
};
StringHelper.formatHoursAndMinutes = (hours) => {
	const minutes = (hours % 1) * 60.0;
	return Math.floor(hours) + " hours " + Math.round(minutes) + " minutes";
};
StringHelper.formatHoursAndMinutes = (hours) => {
	const minutes = (hours % 1) * 60.0;
	return Math.floor(hours) + " hours " + Math.round(minutes) + " minutes";
};
StringHelper.formatMinutesAndSeconds = (minutes) => {
	const seconds = (minutes % 1) * 60.0;
	return Math.floor(minutes) + " minutes " + Math.round(seconds) + " seconds";
};
StringHelper.formatDecimalToDMS = (val, lng = true) => {
	val = GeoHelper.wrapCoord(val, lng);
	const vals = StringHelper._convertDDToDMS(val, lng);
	return `${vals.deg}° ${vals.min}' ${vals.sec}'' ${vals.dir}`;
};
StringHelper.formatLngLat = (lngDecimal, latDecimal, lngLatFormat = LngLatFormat.DECIMAL) => { // TODO: lngLatOrder? (e.g. some may want lat lon)
	if (lngLatFormat === LngLatFormat.DMS) {
		lngDecimal = StringHelper.formatDecimalToDMS(lngDecimal);
		latDecimal = StringHelper.formatDecimalToDMS(latDecimal, false);
	}
	return lngDecimal + ". " + latDecimal;
};

StringHelper._convertDDToDMS = (deg, lng = true) => {
	let d = parseInt(deg);
	const minfloat = Math.abs((deg - d) * 60);
	let m = Math.floor(minfloat);
	const secfloat = (minfloat - m) * 60;
	let s = Math.round(secfloat);
	d = Math.abs(d);

	if (s === 60) {
		m++;
		s = 0;
	}
	if (m === 60) {
		d++;
		m = 0;
	}

	return {
		dir: deg < 0 ? lng ? "W" : "S" : lng ? "E" : "N",
		deg: d,
		min: m,
		sec: s
	};
};
StringHelper.formatDMSToDecimal = (input) => {
	const parts = input.split(/[^\d\w]+/);
	const lng = StringHelper._convertDMSToDD(parseFloat(parts[0]), parseFloat(parts[1]), parseFloat(parts[2]), parts[3]);
	const lat = StringHelper._convertDMSToDD(parseFloat(parts[4]), parseFloat(parts[5]), parseFloat(parts[6]), parts[7]);
	return lng + ", " + lat;
};
StringHelper._convertDMSToDD = (degrees, minutes, seconds, direction) => {
	let dd = degrees + minutes / 60 + seconds / (60 * 60);

	if (direction === "S" || direction === "W") {
		dd = dd * -1;
	} // Don't do anything for N or E
	return dd;
};
StringHelper.splitIMOsByCommaOrSpace = (inputString) => {
	if (inputString.length < 7) return [];
	return StringHelper.splitByCommaOrSpace(inputString);
};
StringHelper.splitMMSIsByCommaOrSpace = (inputString) => {
	if (inputString.length < 9) return [];
	return StringHelper.splitByCommaOrSpace(inputString);
};
StringHelper.splitICAOsByCommaOrSpace = (inputString) => {
	if (inputString.length < 6) return [];
	return StringHelper.splitByCommaOrSpace(inputString);
};

StringHelper.splitByCommaOrSpace = (inputString) => {
	inputString = inputString || "";
	let splitValues = [];
	if (inputString.indexOf(",") >= 0) {
		splitValues = inputString.split(",");
		for (let i = 0; i < splitValues.length; i++) {
			splitValues[i] = splitValues[i].trim();
		}
	}
	else {
		splitValues = inputString.split(" ");
	}
	return splitValues.filter(v => v !== "");
};
StringHelper.numberpad = (str, padWidth = 2, padCharacter = "0") => {
	while (str.length < padWidth) {
		str = padCharacter + str;
	}
	return str;
};
StringHelper.replaceAll = (str, find, replace) => {
	while (str.indexOf(find) >= 0) {
		str = str.replace(find, replace);
	}
	return str;
};
StringHelper.nl2br = (str) => {
	return StringHelper.replaceAll(str, "\r\n", "<br/>");
};

export default StringHelper;
